


import { artboardMiddleware } from './artboard';
import { boundsMdl } from './bounds/middleware';
import { canvasMdl } from './canvas/middleware';
import { colorsMdl } from './colors';
import { dataMiddleware } from './map/data';
import { dropMiddleware } from './map/drop';
import { inspectMiddleware } from './inspect';
import { mapMiddleware } from './map';
import { screensMdl } from './screens/middleware';
import { tokensMdl } from "./tokens/middleware";
import { typesMdl } from './typography';
import { updateMiddleware } from './update';


import { addMiddleware } from 'redux-dynamic-middlewares';

export const addBuilderMdl = () => {
    // addMiddleware(...[
    //     ...dropMiddleware,
    //     ...dataMiddleware,
    //     ...mapMiddleware,

    //     ...inspectMiddleware,
    //     ...updateMiddleware,

    //     ...artboardMiddleware,
    //     ...canvasMdl,
    //     ...screensMdl,
    //     ...tokensMdl,
    //     ...colorsMdl,
    //     ...typesMdl,

    //     ...boundsMdl,
    // ])
}